import { toast } from "react-toastify";
import axiosInstance from "../../../../axiosInstance";
import { HRMS_LMS_API_URL } from "../../../Constants/baseConstant";
import { getUserData, getUserId } from "../../Base/helper/baseFunctions";
import NProgress from 'nprogress';


export const GetOptionalHolidayCalendarHelper = async (params) => {
    var data = getUserData();
    NProgress.start();
    return await axiosInstance(`/ancillary/lms/getOptionalCalendar`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: params?.domain_name || data?.domain,
            year: params?.year || new Date().getFullYear(),
        }
    })
        .then((res) => {
            toast.dismiss();
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            NProgress.done();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpsertOptionalHolidayCalendarHelper = async (params) => {
    const year = parseInt(new Date(params?.date).getFullYear());
    toast.info("Saving...")
    var data = getUserData();
    return await axiosInstance(`/ancillary/lms/upsertOptionalCalendar`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
            year: year,
            name: params?.name,
            date: params?.date,
            description: params?.description || "",
            optional_holidaycalendar_pk: params?.optional_holidaycalendar_pk ? +params.optional_holidaycalendar_pk : null
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Optional Holiday Saved Successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Failed to save holiday")
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const DeleteOptionalHolidayCalendarHelper = async (params) => {  
    toast.info("Deleting...")
    var data = getUserData();
    return await axiosInstance(`/ancillary/lms/deleteOptionalCalendar`, {
        method: "DELETE",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            year: params?.year,
            optional_holidaycalendar_ids: params?.optional_holidaycalendar_ids,
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Optional Holiday Deleted Successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Failed to delete holiday")
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const GetEmployeeOptionalHolidayCalendarHelper = async (params) => {
    var data = getUserData();

    return await axiosInstance(`/ancillary/lms/getEmployeeOptionalCalendar`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            year: params?.year || new Date().getFullYear(),
            employee_fk: params?.employee_fk || null,
            user_id: getUserId()
        }
    })
        .then((res) => {
            toast.dismiss();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpsertEmployeeOptionalHolidayCalendarHelper = async (params) => {
    params?.toast && toast.dismiss();
    params?.toast && toast.info("Saving...")
    var data = getUserData();
    return await axiosInstance(`/ancillary/lms/upsertEmployeeOptionalCalendar`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
            employee_fk: +params?.employee_fk,
            optional_holidaycalendar_pk: +params?.optional_holidaycalendar_pk,
            reason_description: params?.reason_description || "",
            year: params?.year || new Date().getFullYear()
        }
    })
        .then((res) => {
            params?.toast && toast.dismiss();
            params?.toast && toast.success("Optional Holiday Allocated Successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            params?.toast && toast.dismiss();
            params?.toast && toast.error(err?.response?.data?.error?.[0]?.message || "Failed to allocate optional leave")
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const DeleteEmployeeOptionalHolidayCalendarHelper = async (params) => {
   params?.toast !== "updating" && toast.dismiss();  
   params?.toast !== "updating" && toast.info("Deleting...")
    var data = getUserData();
    return await axiosInstance(`/ancillary/lms/deleteEmployeeOptionalCalendar`, {
        method: "DELETE",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            year: params?.year,
            employee_optional_holidaycalendar_ids: params?.employee_optional_holidaycalendar_ids,
            user_id: getUserId()
        }
    })
        .then((res) => {
           params?.toast !== "updating" && toast.dismiss();
           params?.toast !== "updating" && toast.success("Optional Holiday Allocation Deleted Successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Failed to remove allocation")
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}
